function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useMemo, useCallback, memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { useToggler } from '@cbhq/cds-common';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack, HStack, Box, Divider } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextBody } from '@cbhq/cds-web/typography';
import { GLOBAL_EDITION_CODE } from '../../../GlobalPreferences/constants.js';
import { useDisplayDetails } from '../../../GlobalPreferences/hooks/useDisplayDetails.js';
import { isGlobalEdition } from '../../../GlobalPreferences/utils/isGlobalEdition.js';
import GlobalPreferencesModal from '../../../GlobalPreferences/GlobalPreferencesModal.js';
import { SCREEN_IDS } from '../../../GlobalPreferences/useGlobalPreferenceNavigation.js';
import { titleMessages } from '../../messages.js';
import devices from '../../shared/styles/devices.js';
import { learnUrl } from '../../shared/utils/links.js';
import useIsSubfolder from '../../shared/utils/useIsSubfolder.js';
import Copyright from '../Copyright.js';
import Social from '../Social.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
const i18nKey = 'BrandColumn';
const messages = defineMessages({
  globeAccessabilityLabel: {
    id: `${i18nKey}.globeAccessabilityLabel`,
    defaultMessage: 'Open global preferences',
    description: `
      #Component: Button:accessibilityLabel
      #CharLimit: 100
      #Context: accessibility label for the globe button to open the global preferences modal`
  }
});
const COINBASE_LOGO_URL = 'https://images.ctfassets.net/q5ulk4bp65r7/3TBS4oVkD1ghowTqVQJlqj/2dfd4ea3b623a7c0d8deb2ff445dee9e/Consumer_Wordmark.svg';
const COINBASE_LOGO_URL_WHITE = 'https://images.ctfassets.net/q5ulk4bp65r7/3d0nJDFOq4TdewlmTxQ6Eb/e94dcbc5ac72d84e812bccc8561c6b62/Consumer_Wordmark_White.svg';
const LOGO_HEIGHT = 20;
const LOGO_WIDTH = 112; // LOGO_HEIGHT * 5.6
const LOGO_HEIGHT_MOBILE = 28;
const LOGO_WIDTH_MOBILE = 156.8; // LOGO_HEIGHT_MOBILE * 5.6

function BrandColumn({
  themeMode,
  userLocaleInfo,
  localeInformation
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const isLearnPage = useIsSubfolder(learnUrl);
  const countryFromUrl = userLocaleInfo.countryFromUrl,
    countryFromIp = userLocaleInfo.countryFromIp,
    languageCode = userLocaleInfo.languageCode,
    localeFromUrl = userLocaleInfo.localeFromUrl;
  const _useState = useState(SCREEN_IDS.main),
    _useState2 = _slicedToArray(_useState, 2),
    globalPreferenceScreen = _useState2[0],
    setGlobalPreferenceScreen = _useState2[1];
  const countryCode = useMemo(() => {
    return isGlobalEdition({
      countryFromUrl,
      languageCode,
      countryFromIp,
      localeFromUrl
    }) ? GLOBAL_EDITION_CODE : countryFromUrl || '';
  }, [countryFromUrl, countryFromIp, languageCode, localeFromUrl]);
  const _useDisplayDetails = useDisplayDetails(countryCode, languageCode || '', localeInformation?.localeCodeToDisplayName ?? {}, userLocaleInfo?.localeFromUrl ?? ''),
    _useDisplayDetails$co = _useDisplayDetails.countryName,
    countryName = _useDisplayDetails$co === void 0 ? '' : _useDisplayDetails$co,
    _useDisplayDetails$la = _useDisplayDetails.languageName,
    languageName = _useDisplayDetails$la === void 0 ? '' : _useDisplayDetails$la;
  const _useToggler = useToggler(),
    _useToggler2 = _slicedToArray(_useToggler, 2),
    isCountryModalOpen = _useToggler2[0],
    _useToggler2$ = _useToggler2[1],
    showCountryModal = _useToggler2$.toggleOn,
    closeCountryModal = _useToggler2$.toggleOff;
  const handleGlobeClick = useCallback(() => {
    setGlobalPreferenceScreen(SCREEN_IDS.main);
    showCountryModal();
  }, [showCountryModal]);
  const handleCountryClick = useCallback(() => {
    setGlobalPreferenceScreen(SCREEN_IDS.country);
    showCountryModal();
  }, [showCountryModal]);
  const handleLanguageClick = useCallback(() => {
    setGlobalPreferenceScreen(SCREEN_IDS.language);
    showCountryModal();
  }, [showCountryModal]);
  return /*#__PURE__*/jsxs(VStack, {
    spacingStart: 0.5,
    spacingEnd: 0.5,
    spacingBottom: 4,
    children: [/*#__PURE__*/jsx(CoinbaseLogo, {
      src: themeMode === 'dark' ? COINBASE_LOGO_URL_WHITE : COINBASE_LOGO_URL,
      alt: formatMessage(titleMessages.coinbaseLogo),
      loading: "lazy",
      height: LOGO_HEIGHT,
      width: LOGO_WIDTH
    }), !isLearnPage && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Copyright, {}), /*#__PURE__*/jsx(Social, {})]
    }), localeInformation && /*#__PURE__*/jsxs(HStack, {
      gap: 1,
      spacingTop: 3,
      alignItems: "center",
      children: [/*#__PURE__*/jsx(Pressable, {
        background: "transparent",
        onPress: handleGlobeClick,
        accessibilityLabel: formatMessage(messages.globeAccessabilityLabel),
        children: /*#__PURE__*/jsx(Icon, {
          size: "s",
          name: "globe",
          color: "foreground"
        })
      }), isCountryModalOpen && /*#__PURE__*/jsx(GlobalPreferencesModal, {
        screenId: globalPreferenceScreen,
        onRequestClose: closeCountryModal,
        countryCode: countryFromUrl || '',
        languageCode: languageCode || '',
        countryCodeFromIP: countryFromIp || '',
        localeInformation: localeInformation,
        localeFromUrl: localeFromUrl || ''
      }), /*#__PURE__*/jsx(Pressable, {
        background: "transparent",
        onPress: handleCountryClick,
        children: /*#__PURE__*/jsx(TextBody, {
          as: "p",
          color: "foregroundMuted",
          children: countryName
        })
      }), /*#__PURE__*/jsx(Box, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/jsx(Divider, {
          direction: "vertical",
          color: "lineHeavy",
          height: "15px"
        })
      }), /*#__PURE__*/jsx(Pressable, {
        background: "transparent",
        onPress: handleLanguageClick,
        children: /*#__PURE__*/jsx(TextBody, {
          as: "p",
          color: "foregroundMuted",
          children: languageName
        })
      })]
    })]
  });
}
const CoinbaseLogo = styled.img`
  display: block;
  margin-bottom: 32px;
  height: ${LOGO_HEIGHT}px;
  width: ${LOGO_WIDTH}px;

  @media (${devices.phone}) {
    height: ${LOGO_HEIGHT_MOBILE}px;
    width: ${LOGO_WIDTH_MOBILE}px;
  }
`;
const BrandColumn$1 = /*#__PURE__*/memo(BrandColumn);
export { BrandColumn$1 as default };
//# sourceMappingURL=BrandColumn.js.map
